import { Modal, UploadProps, message, notification } from "antd";
import { InboxOutlined } from '@ant-design/icons';
import React, { Key, useState } from "react";
import usePermissionsApi from "../../../services/reportGateway/api/permissionsApi";
import { useQuery } from "react-query";
import Dragger from "antd/lib/upload/Dragger";

const ClientKey = 'client';
const ProviderKey = 'provider';
const PermissionKey = 'permission';
interface IPermissionsImportProps {
  open: boolean;
  onOk(): void;
  onCancel(): void;
}

export function PermissionsImport(props: IPermissionsImportProps) {
  const { open, onOk, onCancel } = props;

  const permissionsApi = usePermissionsApi();

  const [uploaded, setUploaded] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [content, setContent] = useState("");

  const uProps: UploadProps = {
    name: 'file',
    multiple: true,
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    beforeUpload: (file) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          if (typeof reader.result === 'string'){
            setContent(reader.result);
            setUploaded(false)
          }

          message.success('Файл успешно прочитан и парсирован.');
        } catch (error) {
          message.error('Ошибка при чтении или парсинге файла.');
        }
      };

      reader.readAsText(file);

      return false;
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} файл успешно загружен.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} не удалось загрузить файл.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  async function handleOnOk() {
    permissionsApi.import(content)
    onOk()
  }

  return (
    <Modal
      title='Импорт разрешений'
      width={900}
      open={open}
      closable={false}
      maskClosable={false}
      onOk={handleOnOk}
      okText='Импорт'
      okButtonProps={{ loading: isProcessing, disabled: uploaded }}
      onCancel={onCancel}
      cancelText='Отмена'
      cancelButtonProps={{ disabled: isProcessing }}
    >
      <Dragger {...uProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Нажмите или перенесите файл в область загрузки</p>
      </Dragger>

    </Modal>
  )
}